import { render } from "./DiscountList.vue?vue&type=template&id=3a0ed586&scoped=true"
import script from "./DiscountList.vue?vue&type=script&lang=js"
export * from "./DiscountList.vue?vue&type=script&lang=js"

import "./DiscountList.vue?vue&type=style&index=0&id=3a0ed586&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0ed586"]])

export default __exports__